const LOCAL_CACHE_TIME = 1000 * 60 * 5; // 5 minutes

export const createCache = (time = LOCAL_CACHE_TIME) => {
	const storage = new Map();

	const del = key => {
		storage.delete(key);
	};

	const set = (key, record) => {
		storage.set(key, {
			record,
			modified: Date.now(),
		});
	};

	const get = key => {
		const entry = storage.get(key);

		if (!entry || entry.modified + time < Date.now()) {
			del(key);

			return null;
		}

		return entry.record;
	};

	return {
		del,
		set,
		get,
	};
};
